import { useClearRefinements, useToggleRefinement } from 'react-instantsearch';
import { Facets } from '~/services/instantsearch';
import useOptimizedRefinementList from '~/shared/hooks/useOptimizedRefinementList';

// Must be used inside the product list <Index>, like any other refinement widget.
export const useStoreAvailability = () => {
    const { value: online, refine: refineOnline } = useToggleRefinement({
        attribute: Facets.STORE_WEB,
    });
    const { value: anyStore, refine: refineAnyStore } = useToggleRefinement({
        attribute: Facets.STORE_ANY,
    });
    const { allItems: storeItems, refine: toggleStore } = useOptimizedRefinementList({
        attribute: Facets.STORE,
    });
    const { refine: clearStores } = useClearRefinements({ includedAttributes: [Facets.STORE] });

    const selectedStores = storeItems.filter((item) => item.isRefined).map((item) => item.value);

    const setIsOnlineEnabled = (enabled: boolean) => {
        if (enabled !== online.isRefined) refineOnline(online);
    };

    const setIsStoreEnabled = (enabled: boolean) => {
        if (enabled !== anyStore.isRefined) refineAnyStore(anyStore);
        if (!enabled) clearStores();
    };

    return {
        isOnlineEnabled: online.isRefined,
        isStoreEnabled: anyStore.isRefined || selectedStores.length > 0,
        selectedStores,
        storeItems,
        onlineCount: online.onFacetValue.count,
        anyStoreCount: anyStore.onFacetValue.count,
        setIsOnlineEnabled,
        setIsStoreEnabled,
        toggleStore,
        clearStores,
    };
};
